/* eslint-disable no-restricted-imports */
import { Box, Typography } from '@material-ui/core';

import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function ProgressBar({
  label,
  value,
  color = '#7B1FA2',
  backgroundColor = '#F3E5F5',
  info,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.labelRow}>
        <Typography variant='body2' color='textSecondary'>
          {label}
        </Typography>
        {info && (
          <Typography variant='body2' style={{ fontWeight: 600, color }}>
            {info}
          </Typography>
        )}
      </Box>
      <Box className={classes.progressContainer} style={{ backgroundColor }}>
        <Box
          className={classes.progressBar}
          style={{
            width: `${value}%`,
            backgroundColor: color,
          }}
        />
      </Box>
    </Box>
  );
}

ProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  info: PropTypes.string,
};
